(function () {
	'use strict';

	angular.module('smb-app')
		.factory('smbContentTypeConfigService', ['$http', '$q', 'gettextCatalog', 'pxUriPathService', ContentTypeConfigService]);

	/**
	 * @ngdoc service
	 * @name smb-app.smbContentTypeConfigService
	 * 
	 * @description
	 * Exposes methods for retrieving, updating, and creating content types.
	 */
	function ContentTypeConfigService($http, $q, gettextCatalog, pxUriPathService) {

		return {
			/**
			 * @ngdoc method
			 * @name smbContentTypeConfigService.getContentType
			 * @methodOf smb-app.smbContentTypeConfigService
			 * @kind function
			 * 
			 * @description
			 * Retrieves a single content type by id.
			 * 
			 * @param {String} groupId Id of the content type group the type belongs to
			 * @param {String} id The id of the content type to retrieve.
			 * 
			 * @returns {Deferred} Returns a promise that resolves to the content type.
			 */
			getContentType: getContentType,

			/**
			 * @ngdoc method
			 * @name smbContentTypeConfigService.addContentType
			 * @methodOf smb-app.smbContentTypeConfigService
			 * @kind function
			 * 
			 * @description
			 * Creates a new content type that belongs to a specific content type group
			 * 
			 * @param {String} groupId Id of the content type group the new content type belongs to
			 * @param {Object} contentType An object that represents the new content type
			 * 
			 * @returns {Deferred} Returns a promise that resolves to the newly created content type.
			 */
			addContentType: addContentType,

			/**
			 * @ngdoc method
			 * @name smbContentTypeConfigService.updateContentType
			 * @methodOf smb-app.smbContentTypeConfigService
			 * @kind function
			 * 
			 * @description
			 * Updates an existing content type
			 * 
			 * @returns {Deferred} Returns a promise that resolves to the updated content type.
			 */
			updateContentType: updateContentType
		};

		function getContentType(groupId, id) {
			if (!id) {
				return $q.reject(new Error(gettextCatalog.getString('Missing required document type id')));
			}
			var uri = pxUriPathService.resolvePath('/f/' + id);
			return $http.get(uri)
				.then(function (response) {
					return response.data;
				});
		}

		function addContentType(groupId, contentType) {
			if (!groupId) {
				return $q.reject(new Error(gettextCatalog.getString('Missing required document type group id')));
			} else if (!contentType) {
				return $q.reject(new Error(gettextCatalog.getString('Missing required document type')));
			}

			var uri = pxUriPathService.resolvePath('/libraries/' + groupId + '/folders');
			return $http.post(uri, contentType)
				.then(function (response) {
					return response.data;
				});
		}

		function updateContentType(groupId, contentType) {
			if (!groupId) {
				return $q.reject(new Error(gettextCatalog.getString('Missing required document type group id')));
			} else if (!contentType) {
				return $q.reject(new Error(gettextCatalog.getString('Missing required document type')));
			}
			return $http.patch(pxUriPathService.resolvePath('/f/' + contentType.FolderId), contentType)
				.then(function(res) {
					return res.data;
				});
		}
	}

}());


//////////////////
// WEBPACK FOOTER
// ./app/services/contentConfigServices/contentTypeConfigService.js
// module id = 135
// module chunks = 1